<div class="step-container registration-account-verification">
  <h5 class="account-verification-title">{{ 'fgbcl.registration.account.verification.title' | translate }}</h5>

  <div class="account-container">
    <h6 class="account-verification-subtitle">{{ 'fgbcl.registration.account.verification.subtitle' | translate }}</h6>
    <p
      class="account-verification-message"
      [innerHTML]="'fgbcl.registration.account.verification.message' | translate | markdownTranslate"
    ></p>
    <div class="account-verification-form">
      <div class="form-floating">
        <input
          id="string"
          type="text"
          class="form-control"
          [formControl]="emailFormControl"
          [placeholder]="'fgbcl.registration.account.verification.email.label' | translate"
        />
        <label for="string">{{ 'fgbcl.registration.account.verification.email.label' | translate }}</label>
      </div>
      <div class="error-message" *ngIf="emailFormControl.hasError('pattern') && emailFormControl.touched">
        {{ 'fgbcl.registration.account.verification.email.error.invalid' | translate }}
      </div>
      <div class="error-message" *ngIf="emailFormControl.hasError('required') && emailFormControl.touched">
        {{ 'fgbcl.registration.account.verification.email.error.required' | translate }}
      </div>
      <ng-content select=".form-error-message"></ng-content>
    </div>
    <div class="action-wrapper">
      <button class="cancel-btn btn text-danger fw-bold" (click)="cancel()">
        {{ 'fgbcl.registration.account.verification.cancel' | translate }}
      </button>
      <button class="submit-btn btn btn-success fw-bold" (click)="submitStep()">
        {{ 'fgbcl.registration.account.verification.submit' | translate }}
      </button>
    </div>
  </div>
</div>
